/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="toggle-tag"]');
  if (!btn) return;

  var group = btn.closest('.collection__filter-group');
  if (!group) return;

  group.querySelectorAll('[data-action="toggle-tag"].is-selected').forEach(function(selected) {
    if (selected !== btn) {
      selected.click();
    }
  });
}, true);


// カート通信欄の制御
document.addEventListener('DOMContentLoaded', function() {
  var noteField = document.querySelector('textarea[name="cart[note]"]');
  if (!noteField) return;

  // ①オープン状態にする
  setTimeout(function() {
    var collapsible = document.querySelector('#order-note');
    var toggleBtn = document.querySelector('[aria-controls="order-note"]');

    if (collapsible) {
      collapsible.classList.add('is-open', 'is-visible');
      collapsible.setAttribute('aria-hidden', 'false');
      collapsible.style.height = 'auto';
      collapsible.style.overflow = 'visible';
    }

    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'true');
    }
  }, 500);

  // ②言語判定
  var lang = document.documentElement.lang || 'ja';
  var isJa = lang.startsWith('ja');

  // ③プレースホルダー
  noteField.setAttribute(
    'placeholder',
    isJa
      ? '※スペース・改行・Enterキーは入力できません'
      : '※Consecutive spaces and Enter key are not allowed'
  );

  // ④エラーメッセージ
  var errorMsg = document.createElement('p');
  errorMsg.style.cssText =
    'color:red; font-size:0.85em; margin-top:4px; display:none;';

  noteField.parentElement.appendChild(errorMsg);

  function showError(msg) {
    errorMsg.textContent = msg;
    errorMsg.style.display = 'block';

    clearTimeout(errorMsg.timer);
    errorMsg.timer = setTimeout(function() {
      errorMsg.style.display = 'none';
    }, 2000);
  }

  // ⑤キー入力制御
  noteField.addEventListener('keydown', function(e) {

    // -------------------
    // 日本語
    // -------------------
    if (isJa) {

      if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
        e.preventDefault();
        showError('※スペース・改行・Enterキーは入力できません');
      }

    // -------------------
    // 英語
    // -------------------
    } else {

      // Enter禁止
      if (e.key === 'Enter') {
        e.preventDefault();
        showError('Enter key is not allowed.');
        return;
      }

      // 連続スペース禁止
      if (e.key === ' ' || e.code === 'Space') {

        var pos = this.selectionStart;
        var val = this.value;

        var prev = val.charAt(pos - 1);
        var next = val.charAt(pos);

        if (prev === ' ' || next === ' ') {
          e.preventDefault();
          showError('Consecutive spaces are not allowed.');
        }
      }
    }

  });

  // ⑥貼り付け・IME補正
  noteField.addEventListener('input', function() {

    var before = this.value;
    var after = before;

    // 日本語
    if (isJa) {

      after = before.replace(/[\n\r \u3000]/g, '');

    // 英語
    } else {

      // 改行削除
      after = after.replace(/[\n\r]/g, '');

      // 連続スペース → 1個
      after = after.replace(/ {2,}/g, ' ');
    }

    if (before !== after) {
      this.value = after;
    }

  });

});
